import React, { useState } from 'react';
import axios from 'axios';
import {  Button,
} from '@chakra-ui/react';

const FileUploadPage = ({esm_id, existingFileId, onUpdated}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [responseMessage, setResponseMessage] = useState('');

  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleSubmission = async () => {
    if (!esm_id?.$oid) {
      setResponseMessage('Missing ESM id.');
      return;
    }
    if (selectedFile) {
      try {
        const formData = new FormData();
        formData.append('pdf_file', selectedFile); // Match the field name on the server

        const response = await axios.post(
          `${process.env.REACT_APP_HOSTNAME}/upload_executive_sheet?esm_id=${esm_id.$oid}`, // Pass esm_id as a query parameter
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );

        setResponseMessage(response.data.response);
        if (onUpdated) {
          onUpdated();
        }
      } catch (error) {
        console.error('Error uploading PDF:', error);
        setResponseMessage('Error while uploading the file!');
      }
    } else {
      setResponseMessage('Please select a PDF file before uploading.');
    }
  };

  const handleDelete = async () => {
    if (!esm_id?.$oid) {
      setResponseMessage('Missing ESM id.');
      return;
    }
    if (!existingFileId) {
      setResponseMessage('No file attached.');
      return;
    }
    const confirmed = window.confirm('Delete the executive sheet file?');
    if (!confirmed) {
      return;
    }

    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_HOSTNAME}/delete_document`,
        {
          params: { esm_id: esm_id.$oid, doc_type: "executive_sheet" },
        }
      );
      setResponseMessage(response.data.message || 'File deleted successfully.');
      if (onUpdated) {
        onUpdated();
      }
    } catch (error) {
      console.error('Error deleting file:', error);
      setResponseMessage(error.response?.data?.message || 'Error while deleting the file!');
    }
  };

  return (
    <div>
      <input type="file" name="file" onChange={changeHandler} />
      <div>
        <Button colorScheme='blue' mr={4} onClick={handleSubmission}>Submit file</Button>
        <Button colorScheme='red' variant='outline' onClick={handleDelete} isDisabled={!existingFileId}>Delete file</Button>
      </div>
      <div>
        <p>{responseMessage}</p>
      </div>
    </div>
  );
};

export default FileUploadPage;
